<script>
import CommonConstants from '../../../common/Constants';
import config from '../../../common/genericPanelConf';
import Utils from '../../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Service from '@/services/planning';
import CommonService from '@/services/common';
import GenericBooleanDropdown from '../../../components/generic/GenericBooleanDropdown.vue';
import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue';
import GenericDataTable from '../../../components/generic/GenericDataTable.vue';

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
    GenericBooleanDropdown,
    ResponsiveButton,
    GenericDataTable
  },
  data(){
    return {
       filters: {
        monthStartDate: null,
        endingInventoryDate: null,
        poolName: null,
        isFinal: false
       },

       invoicePrices: []
    }
  },
  validations(){
    return {
        
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.configuration = config.getConfiguration('InvoicePrices');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'InvoicePrices.page_title');
  },
  methods: {
    loadData(){

      let body = {
        monthStartDate: Utils.formatDateForAPI(Utils.dateToCurrentTimeZone(this.filters.monthStartDate)),
        endingInventoryDate: Utils.formatDateForAPI(this.filters.endingInventoryDate),
        poolName: this.filters.poolName,
        isFinal: this.filters.isFinal
      };
      this.$refs.invoicePrices.filterFromView(body, true);
    },
    exportExcel(){
      let body = {
        monthStartDate: Utils.formatDateForAPI(Utils.dateToCurrentTimeZone(this.filters.monthStartDate)),
        endingInventoryDate: Utils.formatDateForAPI(this.filters.endingInventoryDate),
        poolName: this.filters.poolName,
        isFinal: this.filters.isFinal
      };

      this.$store.dispatch("generic/setLoading", true);
      let fileNameWithExtension = "InvoicePrices.xlsx";
      Service.exportInvoicePrices(body, ({success, data, message}) => {
          this.$store.dispatch("generic/setLoading", false);
  
          if(success){
              var fileURL = window.URL.createObjectURL(new Blob([data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', fileNameWithExtension);
              document.body.appendChild(fileLink);
          
              fileLink.click();
          } else{
              this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
      })
    }
  }
}

</script>

<template>
    <main>
      <div class="m-5">
        <div class="grid">
            <div class="col-2">
                <label for="monthStartDate">{{$t('InvoicePrices.monthStartDate')}}</label>
                <Calendar
                class="p-inputtext-sm w-full"
                :placeholder="'MM/YYYY'"
                v-model="this.filters.monthStartDate"
                name="endingInventoryDate" dateFormat="mm/yy" :showTime="false"
                view="month" 
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>

            <div class="col-2">
                <label for="endingInventoryDate">{{$t('InvoicePrices.endingInventoryDate')}}</label>
                <Calendar
                class="p-inputtext-sm w-full"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                v-model="this.filters.endingInventoryDate"
                name="endingInventoryDate" dateFormat="dd/mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>

            <div class="col-2">
                <label for="familyPool">{{$t('InvoicePrices.isFinal')}}</label>
                <GenericBooleanDropdown class="w-full" v-model="this.filters.isFinal" /> 
            </div>

            <div class="col-4">
              <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="my-4 mx-2 p-button-sm" @click="loadData" />
              <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="my-4 mx-2 p-button-sm" @click="exportExcel" />
            </div>

            <div class="col-12">
              <GenericDataTable :configuration="configuration" :category="'planning'" :name="'true-up-invoice-prices'" 
              ref="invoicePrices"  />
            </div>
        </div>
      </div>
    </main>
</template>